<template>
  <div class="col-md-12" v-show="dashboardBookings.length">
    <div class="panel panel-default">
      <div class="panel-title">
        <h3>Réservations à venir</h3>
        <router-link tag="button" :to="{ name: 'one-time-locations' }" class="btn btn-sm btn-primary top-right m-b-15">Voir tout</router-link>
      </div>
      <div class="panel-body">
        <upcoming-reservations-item v-for="(upcomingReservation, index) in filteredByDateBookings" :key="index" :dayUpcomingReservation="dayUpcomingReservation(upcomingReservation)"></upcoming-reservations-item>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .panel {
    padding: 0;
    background: transparent;
    border: none;
    @media all and (max-width: 767px) {
      padding: 0 20px;
    }
    .panel-title {
      position: relative;
      h3 {
        margin-top: 10px;
        margin-bottom: 10px;
        position: relative;
      }
      button {
        position: absolute;
        right: 5px;
      }
    }
    .panel-body {
      padding: 0;
      background: #fff;
    }
  }
</style>

<script type="text/babel">
import { mapState, mapActions } from 'vuex'

import UpcomingReservationsItem from 'components/Dashboard/UpcomingReservations/UpcomingReservationsItem'

export default {
    name: "UpcomingReservations",

    components: {
        UpcomingReservationsItem
    },

    created () {
        const userAgencies = this.user.agencies.map((agency) => agency.id)

        this.fetchDashboardBookings({
            agencies: userAgencies,
            period: 'future',
            per_page: 5,
            canceled: 0,
            with: 'suborder;product',
            orderBy: 'start_date'
        })
    },

    computed: {
        ...mapState(['user']),
        ...mapState('bookings', ['dashboardBookings']),

        filteredByDateBookings () {
            let dateArray = _.uniqBy(this.dashboardBookings, (booking) => {
                return moment(booking.start_date).format('dddd DD MMMM YYYY')
            })

            return dateArray
        }
    },

    methods: {
        ...mapActions('bookings', ['fetchDashboardBookings']),

        dayUpcomingReservation (upcomingReservation) {
            return _.filter(this.dashboardBookings, (booking) => {
                return moment(booking.start_date).format('DD/MM/YYYY') == moment(upcomingReservation.start_date).format('DD/MM/YYYY')
            })
        }
    }

}
</script>



// WEBPACK FOOTER //
// client/components/Dashboard/UpcomingReservations/UpcomingReservations.vue